/**
 * SubscriptionStatusService
 * Service for SubscriptionStatus entity operations
 * Route: api/subscriptionstatuses
 * Controller: SubscriptionStatusesController.cs
 */
import { CrudService } from '../base/CrudService';
export class SubscriptionStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SubscriptionStatusService.DEFAULT_SERVICE_PATH,
            basePath: SubscriptionStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
SubscriptionStatusService.DEFAULT_SERVICE_PATH = 'suppliers';
SubscriptionStatusService.BASE_PATH = 'api/subscriptionstatuses';
//# sourceMappingURL=SubscriptionStatusService.js.map